import { render } from "./template_question_mapping.html?vue&type=template&id=ee34f09c&external"
import script from "./template_question_mapping.js?vue&type=script&lang=js&external"
export * from "./template_question_mapping.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__